export const STRAPI_PREVIEW_NAMESPACE = 'strapi-preview';

export function getTranslationNamespaceForStrapiPage(
	contentType: string,
	pageSlug: string,
): string {
	return `strapi-${contentType}-${pageSlug}`;
}

export function getTranslationNamespaceForStrapiPreviewPage(): string {
	return STRAPI_PREVIEW_NAMESPACE;
}
